/* 
    Twobytwo Module 
*/
import cloneDeep from "lodash/cloneDeep";
import d3Utils from "../../../utils/d3Utils";
import chartUtils from "../../../utils/chart-utils";
import twobytwoConfigBuilder from "./twobytwo-config-builder";
import { twobytwoTooltip } from "../../widgets/widget-utilities/widget-tooltip";

var twobytwo = function twobytwo() {
  // Render Twobytwo widget
  var renderWidget = function renderWidget(widgetConfig) {
    var ContainerId = widgetConfig.ContainerId,
        Height = widgetConfig.Height,
        Width = widgetConfig.Width,
        Model = widgetConfig.Model,
        Cloud = widgetConfig.Cloud,
        TwoByTwoConfig = widgetConfig.TwoByTwoConfig,
        Data = widgetConfig.Data;


    var el = window.document.querySelector("#" + ContainerId);
    var parentContainerId = ContainerId.includes("flip-") ? ContainerId.split("flip-")[1] : ContainerId;
    d3.select(el).select("svg").remove();

    // Rendering logic is expecting data to be array of array
    var data = [];
    data.push(chartUtils.tryJsonParse(Data.data));

    var containerWidth = Number(Width);
    var containerHeight = Number(Height);

    var xField = TwoByTwoConfig.XField;
    var yField = TwoByTwoConfig.YField;
    var category = TwoByTwoConfig.NameField;
    var valField = TwoByTwoConfig.ValueField;
    var rangeLabels = TwoByTwoConfig.RangeLabels;
    var xDisplayName = TwoByTwoConfig.XAxisDisplayName;
    var yDisplayName = TwoByTwoConfig.YAxisDisplayName;
    var crumbMetaName = TwoByTwoConfig.CrumbMetaName;
    var crumbFieldName = TwoByTwoConfig.CrumbFieldName;
    var crumbDisplayFieldName = TwoByTwoConfig.CrumpDisplayFieldName;
    var inverseSortForX = TwoByTwoConfig.InverseSortForXAxis;
    var inverseSortForY = TwoByTwoConfig.InverseSortForYAxis;
    var xCurrencyPrefix = TwoByTwoConfig.XAxisCurrencySymbol;
    var yCurrencyPrefix = TwoByTwoConfig.YAxisCurrencySymbol;
    var axisType = TwoByTwoConfig.AxisType;
    var partitionLineType = TwoByTwoConfig.PartitionLineType;
    var stampText = null;
    var showLabels = TwoByTwoConfig.ShowLabels;
    var tooltipConfig = TwoByTwoConfig.CompoundTipField;
    var xDisplayFormat = TwoByTwoConfig.xDisplayFormat;
    var xBaseFormat = TwoByTwoConfig.XAxisBaseFormat;
    var yDisplayFormat = TwoByTwoConfig.YAxisValueFormat;
    var yBaseFormat = TwoByTwoConfig.YAxisBaseFormat;

    var aggregationType = TwoByTwoConfig.AggregationType;
    var accumulator = [];
    var tempAccumulator = [];

    var showLegend = TwoByTwoConfig.ShowLegend;

    var legendScale = Math.min(containerWidth, containerHeight);
    var legendRectSize = 0.02 * legendScale;
    var legendVerticalPad = containerHeight * 0.1;
    var legendWidthPad = containerWidth * 0.1;
    var legendPosition = TwoByTwoConfig.LegendPosition.toLowerCase();

    var marginpercent = 4 / 100;
    var margin = {
      top: marginpercent * containerHeight,
      right: marginpercent * containerWidth,
      bottom: marginpercent * containerHeight,
      left: marginpercent * containerWidth
    };
    var width = containerWidth - margin.left - margin.right;
    var height = containerHeight - margin.top - margin.bottom;

    if (showLegend) height = containerHeight - margin.top - margin.bottom - legendRectSize - legendVerticalPad;

    var crumbFormat = {
      CloudName: Cloud,
      ModelName: Model,
      Type: "Node",
      Name: crumbMetaName,
      FieldName: crumbFieldName,
      Value: null,
      DisplayFieldName: crumbDisplayFieldName,
      DisplayValue: null
    };

    var padleft = 0;
    var padTop = 0;
    var svgWidth = width + margin.left;
    var svgHeight = height + margin.top + legendRectSize + legendVerticalPad;

    if (width < height) {
      padTop = height / 2 - width / 2;
      height = width;
    } else {
      padleft = width / 2 - height / 2;
      width = height;
    }

    if (legendPosition == "") legendPosition = "bottom";

    if (legendPosition == "bottom") height = height - legendRectSize - legendVerticalPad;

    if (legendPosition == "right") height = width - legendRectSize - legendVerticalPad;

    var svg = d3.select(el).append("svg").attr("id", "twobytwo").attr("width", svgWidth).attr("height", svgHeight).attr("viewBox", "0 0 " + svgWidth + " " + svgHeight).attr("preserveAspectRatio", "xMidYMid").attr("class", "maximize-trigger");
    var chartSVG = svg.append("g").attr("class", "bubbles").style("width", "60%").attr("transform", "translate(" + (margin.left + padleft) + "," + (margin.top + padTop) + ")");

    if (aggregationType == "") tempAccumulator = data[0];else {
      for (var dataIndex = 0; dataIndex < data[0].length; dataIndex++) {
        var item = data[0][dataIndex];
        var index = tempAccumulator.map(function (e) {
          return e[crumbFieldName];
        }).indexOf(item[crumbFieldName]);
        if (index == -1) {
          item["counter"] = 1;
          tempAccumulator.push(item);
        } else {
          tempAccumulator[index]["counter"]++;
          switch (aggregationType.toLowerCase()) {
            case "average":
              tempAccumulator[index][xField] = (Number(tempAccumulator[index][xField]) * (tempAccumulator[index]["counter"] - 1) + Math.round(Number(item[xField]) * 100) / 100) / tempAccumulator[index]["counter"];
              tempAccumulator[index][yField] = (Number(tempAccumulator[index][yField]) * (tempAccumulator[index]["counter"] - 1) + Math.round(Number(item[yField]) * 100) / 100) / tempAccumulator[index]["counter"];
              if (valField != null && valField != "") tempAccumulator[index][valField] = (Number(tempAccumulator[index][valField]) * (tempAccumulator[index]["counter"] - 1) + Math.round(Number(item[valField]) * 100) / 100) / tempAccumulator[index]["counter"];
              break;
          }
        }
      }
    }

    accumulator = tempAccumulator;

    var maxValRange = 0;
    var radius = 0;
    if (valField != null && valField != "") {
      accumulator.sort(function (a, b) {
        return d3.descending(Number(a[valField]), Number(b[valField]));
      });

      var maxVal = Number(accumulator[0][valField]);
      maxValRange = width < height ? width * 0.2 : height * 0.2;
      var dScale = d3.scale.linear().domain([0, maxVal]).range([1, maxValRange]);
    } else {
      radius = width < height ? width * 0.01 : height * 0.01;
      maxValRange = width < height ? width * 0.0 : height * 0.0;
    }

    var maxX = d3.max(accumulator, function (d) {
      return Number(d[xField]);
    });
    var minX = d3.min(accumulator, function (d) {
      return Number(d[xField]);
    });

    if (axisType == "log") var x = d3.scale.log();else var x = d3.scale.linear();

    x.range([0 + maxValRange, width - maxValRange]);
    x.rangeRound([0 + maxValRange, width - maxValRange]);

    if (inverseSortForX) x.domain([maxX, minX]);else x.domain([minX, maxX]);

    var maxY = d3.max(accumulator, function (d) {
      return Number(d[yField]);
    });
    var minY = d3.min(accumulator, function (d) {
      return Number(d[yField]);
    });

    if (axisType == "log") var y = d3.scale.log();else var y = d3.scale.linear();

    y.range([height - maxValRange, 0 + maxValRange]);
    y.rangeRound([height - maxValRange, 0 + maxValRange]);

    if (inverseSortForY) {
      y.domain([maxY, minY]);
    } else {
      y.domain([minY, maxY]);
    }

    var color = d3.scale.linear().domain([0, accumulator.length - 1]).range(["#404040", "#F9BD3A"]);

    var xAxis = d3.svg.axis().scale(x).orient("bottom").tickFormat(function (d) {
      return chartUtils.format(d, xDisplayFormat, xCurrencyPrefix, maxX, xBaseFormat);
    });

    var yAxis = d3.svg.axis().scale(y).orient("left").tickFormat(function (d) {
      return chartUtils.format(d, yDisplayFormat, yCurrencyPrefix, maxY, yBaseFormat);
    });

    if (axisType == "log") {
      xAxis.ticks(20, ".1s").tickSize(-(height - maxValRange));

      yAxis.ticks(20, ".1s").tickSize(-(width - maxValRange));
    }

    var mainrect = chartSVG.append("rect").attr("x", 0).attr("y", 0).attr("width", width).attr("height", height).attr("class", "mainrect").style("display", function () {
      if (rangeLabels.length > 0) return "block";else return "none";
    });

    var bubble = chartSVG.selectAll("bubbles.bubble").data(accumulator);

    bubble.enter().append("circle").attr("class", function (d, i) {
      return "dataviz bubble bubbleNo" + i + " " + d[category];
    }).attr("cx", function (d) {
      return x(Number(d[xField]));
    }).attr("cy", function (d) {
      return y(Number(d[yField]));
    }).attr("r", function (d) {
      if (valField == "") return radius;else return dScale(Number(d[valField]));
    }).attr("coord", function (d) {
      crumbFormat.Value = d[crumbFieldName];
      crumbFormat.DisplayValue = d[crumbDisplayFieldName];
      return JSON.stringify(crumbFormat);
    }).attr("label", function (d) {
      var defaultTip = "<span class='tip-header'>" + d[category] + ":</span><span class='tip-value'> " + chartUtils.format(d[valField], xDisplayFormat, xCurrencyPrefix, null, xBaseFormat) + "</span><br /><span class='tip-header'>" + xDisplayName + ":</span><span class='tip-value'> " + chartUtils.format(d[xField], xDisplayFormat, xCurrencyPrefix, maxX, xBaseFormat) + "</span><br /><span class='tip-header'>" + yDisplayName + ":</span><span class='tip-value'> " + chartUtils.format(d[yField], xDisplayFormat, yCurrencyPrefix, maxY, yBaseFormat) + "</span>";
      var tipText = chartUtils.buildTooltipText(tooltipConfig, d, defaultTip, valField, aggregationType, null);
      return tipText;
    }).style("fill", function (d, i) {
      return color(i);
    }).on("touchstart", function () {
      twobytwoTooltip.onMouseOver.call(this, parentContainerId);
    }).on("mouseover", function () {
      twobytwoTooltip.onMouseOver.call(this, parentContainerId);
    }).on("mouseout", twobytwoTooltip.onMouseOut).on("touchmove", twobytwoTooltip.onTouchMove).on("mousemove", function () {
      twobytwoTooltip.onMouseMove.call(this, parentContainerId);
    });

    var bubbles = d3.selectAll("#" + ContainerId + " .bubble");

    var bubblesRadius = [];
    bubbles[0].forEach(function (n, i) {
      var circleRadius = d3.select("#" + ContainerId + " .bubbleNo" + i).attr("r");
      bubblesRadius.push(circleRadius);
    });

    bubbles.attr("r", 0);

    bubbles.transition().duration(800).attr("r", function (d, i) {
      return bubblesRadius[i];
    });

    if (showLabels) {
      bubble.enter().append("text").text(function (d) {
        return "\xa0" + d[category];
      }).attr("x", function (d) {
        var r = null;
        if (valField == "") r = radius;else r = dScale(Number(d[valField]));
        return x(Number(d[xField])) + r;
      }).attr("y", function (d) {
        return y(Number(d[yField]));
      }).attr("class", "bubble-label").style("text-anchor", "start");
    }

    var nameHeight = containerHeight * 0.03;

    var _loop = function _loop(rangeIndex) {
      if (rangeIndex != rangeLabels.length) {
        if (rangeIndex != 0) {
          if (partitionLineType != "diagonal") {
            chartSVG.append("line").attr("class", "partitionLines").attr("x1", width / rangeLabels.length * rangeIndex).attr("y1", 0).attr("x2", width / rangeLabels.length * rangeIndex).attr("y2", height);
            chartSVG.append("line").attr("class", "partitionLines").attr("x1", 0).attr("y1", height / rangeLabels.length * rangeIndex).attr("x2", width).attr("y2", height / rangeLabels.length * rangeIndex);
          } else {
            chartSVG.append("line").attr("class", "partitionLines").attr("x1", width).attr("y1", 0).attr("x2", 0).attr("y2", height);
          }
        }
        if (partitionLineType != "diagonal") {
          chartSVG.append("text").text(function () {
            if (inverseSortForX) return rangeLabels[rangeLabels.length - 1 - rangeIndex];else return rangeLabels[rangeIndex];
          }).attr("transform", function () {
            var x = width / rangeLabels.length * rangeIndex + width / rangeLabels.length / 2;
            var y = height + nameHeight;
            return "translate(" + x + "," + y + ")";
          });
          chartSVG.append("text").text(function () {
            if (inverseSortForY) return rangeLabels[rangeIndex];else return rangeLabels[rangeLabels.length - 1 - rangeIndex];
          }).attr("transform", function () {
            var x = -nameHeight;
            var y = height / rangeLabels.length * rangeIndex + height / rangeLabels.length / 2;
            return "translate(" + x + "," + y + ")rotate(-90)";
          });
        } else {
          chartSVG.append("text").text(function () {
            if (inverseSortForX) return rangeLabels[rangeLabels.length - 1 - rangeIndex];else return rangeLabels[rangeIndex];
          }).attr("transform", function () {
            var x = rangeIndex % 2 == 0 ? width / 4 : width * 3 / 4;
            var y = rangeIndex % 2 == 0 ? height / 4 + nameHeight : height * 3 / 4 + nameHeight;
            return "translate(" + x + "," + y + ")";
          });
        }
      } else {
        chartSVG.append("text").text(xDisplayName).attr("transform", function () {
          var x = width / 2;
          var y = height + containerHeight * 0.07;
          return "translate(" + x + "," + y + ")";
        });
        chartSVG.append("text").text(yDisplayName).attr("transform", function () {
          var x = -(containerHeight * 0.1);
          var y = height / 2;
          return "translate(" + x + "," + y + ")rotate(-90)";
        });
      }
    };

    for (var rangeIndex = 0; rangeIndex <= rangeLabels.length; rangeIndex++) {
      _loop(rangeIndex);
    }

    if (showLegend) {
      (function () {
        var legendItems = chartUtils.getUnique(accumulator, category);

        var legendCount = legendItems.length;
        var legendSectionWidth = width / legendCount;

        var vert = 0;

        var legendSVG = void 0;

        if (legendPosition == "bottom") {
          legendSVG = svg.append("g").attr("class", "bubbles").attr("width", width + padleft).attr("height", height).attr("transform", "translate(" + (margin.left + padleft) + "," + (margin.top + padTop) + ")");

          vert = height + legendVerticalPad + containerHeight * 0.04;

          var count = Math.round(legendCount / 2);

          var _loop2 = function _loop2(bottomIndex) {
            if (bottomIndex != 0) {
              if (bottomIndex % 2 == 1) count = count + bottomIndex;else {
                count = count - bottomIndex;
              }
            }

            legendSVG.append("rect").attr("x", count * legendSectionWidth - legendSectionWidth / 2 - 2 - legendRectSize).attr("y", vert - legendRectSize / 2).attr("width", legendRectSize).attr("height", legendRectSize).attr("class", function () {
              return "legend " + legendItems[i];
            }).attr("label", function () {
              return legendItems[bottomIndex];
            }).style("fill", function () {
              return color(bottomIndex);
            });

            var text = legendSVG.append("text").attr("x", count * legendSectionWidth - legendSectionWidth / 2 + 2).attr("y", vert).attr("class", "legend-text " + legendItems[bottomIndex]).style("text-anchor", "start").style("dominant-baseline", "central").text(function () {
              return legendItems[bottomIndex];
            });
          };

          for (var bottomIndex = 0; bottomIndex < legendCount; bottomIndex++) {
            _loop2(bottomIndex);
          }
        }

        var hor = 0;
        if (legendPosition == "right") {
          legendSVG = svg.append("g").attr("class", "bubbles").attr("width", width).attr("height", height).attr("transform", "translate(" + (width + margin.left + padleft) + "," + margin.right + ")");

          hor = containerWidth * 0.04;
          vert += legendWidthPad + containerWidth * 0.02;

          var _loop3 = function _loop3(rightIndex) {
            vert += 18;
            legendSVG.append("rect").attr("x", hor).attr("y", vert).attr("width", legendRectSize).attr("height", legendRectSize).attr("class", function () {
              return "legend " + legendItems[rightIndex];
            }).attr("label", function () {
              return legendItems[rightIndex];
            }).style("fill", function () {
              return color(rightIndex);
            });

            var text = legendSVG.append("text").attr("x", hor + 18).attr("y", vert + 5).attr("class", "legend-text " + legendItems[rightIndex]).style("text-anchor", "start").style("dominant-baseline", "central").text(function () {
              return legendItems[rightIndex];
            });
          };

          for (var rightIndex = 0; rightIndex < legendCount; rightIndex++) {
            _loop3(rightIndex);
          }
        }
      })();
    }

    if (stampText != null && stampText.trim().length > 0) {
      var stampTextContainer = svg.append("g");

      var rectWidth = width / 1.5;
      var rectHeight = 80;

      stampTextContainer.append("foreignObject").attr("x", 0).attr("y", 0).attr("width", rectWidth).attr("height", rectHeight).append("xhtml:body").html("<p class='stampText'>" + stampText + "</p>");
    }
  };

  // Initiate rendering for a widget
  var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
    // Get widget specific widgetConfig
    var widgetConfig = twobytwoConfigBuilder.configBuilder(cloneDeep(configObj));
    renderWidget(widgetConfig);
  };

  return {
    renderWidget: renderWidget,
    initiateWidgetRendering: initiateWidgetRendering
  };
};

export default twobytwo();